import { render, staticRenderFns } from "./surfaceSampleInfoWidget.vue?vue&type=template&id=3c5918e5&scoped=true"
import script from "./surfaceSampleInfoWidget.vue?vue&type=script&lang=js"
export * from "./surfaceSampleInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./surfaceSampleInfoWidget.vue?vue&type=style&index=0&id=3c5918e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5918e5",
  null
  
)

export default component.exports